import * as React from 'react';
const EmailIcon = ({ width = 14, height = 14, ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9.917 12.396H4.083a.44.44 0 0 1-.437-.438.44.44 0 0 1 .437-.437h5.834c1.668 0 2.479-.811 2.479-2.48V4.959c0-1.668-.81-2.479-2.48-2.479H4.084c-1.668 0-2.479.811-2.479 2.48a.44.44 0 0 1-.437.437.44.44 0 0 1-.438-.438c0-2.129 1.225-3.354 3.354-3.354h5.834c2.129 0 3.354 1.225 3.354 3.354v4.084c0 2.129-1.225 3.354-3.354 3.354'
      fill='currentColor'
    />
    <path
      d='M7 7.507c-.49 0-.986-.151-1.365-.46L3.809 5.588a.436.436 0 0 1 .542-.682l1.826 1.458c.444.356 1.196.356 1.64 0l1.825-1.458a.43.43 0 0 1 .613.07.43.43 0 0 1-.07.612L8.359 7.047c-.373.309-.87.46-1.36.46m-2.332 2.556h-3.5a.44.44 0 0 1-.438-.438.44.44 0 0 1 .438-.437h3.5a.44.44 0 0 1 .437.437.44.44 0 0 1-.437.438M2.917 7.73h-1.75a.44.44 0 0 1-.438-.438.44.44 0 0 1 .438-.438h1.75a.44.44 0 0 1 .437.438.44.44 0 0 1-.437.437'
      fill='currentColor'
    />
  </svg>
);
export default EmailIcon;
